<template>
  <div class="home">
    <img class="logo" src="../assets/image/logo.png" alt="">
    <h2>歡迎光臨</h2>
    <h1>靈九道壇管理後台</h1>
  </div>
</template>
<style lang="less">
  div.home{
    position: absolute;
    top:90px!important;
    bottom:0;
    background-image: url(../assets/image/homeback.jpg);
    background-size: 100% 100%;
    .logo{
      width:140px;
      display: block;
      margin-top:200px;
      margin-left:135px;
    }
    h2{
      margin-top:40px;
      font-size: 30px;
    }
    h1{
      font-size: 40px;
    }
    h2,h1{
      color:#472D2E;
      width:400px;
    }
  }
</style>
<script>
export default {
  name: 'home',
  components: {
  },
  created(){
    this.$emit('breadcrumbChange',[])
  }
}
</script>
